import { render, staticRenderFns } from "./addvisits.vue?vue&type=template&id=4cfc5814&"
import script from "./addvisits.vue?vue&type=script&lang=js&"
export * from "./addvisits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports